import { useSearchParams } from "react-router"
import { stringFilterParam } from "../../../hooks/useUrlFilterParams"
import { EntityEmptyDetail } from "../../shared/EntityEmptyDetail"
import { SubstanceArticlesSection } from "./SubstanceArticlesSection"
import { SubstanceAuditSection } from "./SubstanceAuditSection"
import {
  SubstanceFieldsBody,
  SubstanceFieldsHeader,
} from "./SubstanceFieldsSection"

export function SubstanceDetailPanel() {
  const [searchParams, setSearchParams] = useSearchParams()
  const id = searchParams.get("id")
  // Same URL param `SubstanceListPanel` writes — both components read the
  // same browser URL, so no prop drilling/lifted state is needed to agree on
  // which mode is active.
  const [rawView] = stringFilterParam(searchParams, setSearchParams, "view")
  const view = rawView === "catalog" ? "catalog" : "org"

  if (!id) return <EntityEmptyDetail body="MC_MD_EMPTY_SELECT_BODY_SUBSTANCE" />

  return (
    <div className="flex flex-col">
      <SubstanceFieldsHeader view={view} />
      <SubstanceArticlesSection />
      <SubstanceFieldsBody view={view} />
      <SubstanceAuditSection />
    </div>
  )
}
